<template>
    <div class="home-view">
        <Topbar />
        <br>
        <br>
        <div class="container-img mt-2 small pb-1" v-if="!this.retorno">
            <div class="col-md-6 m-auto mt-3">
                <div class="card small">
                    <div class="card-header text-white p-1" :style="{ backgroundColor: moduloAtual().color }">
                        Primeira Conferência
                        <div v-show="carregando" class="spinner-grow">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    <div class="card-body p-1 text-left">

                        <InputDefaultApp
                            inputPlaceHolderSufixo="Digite a chave da nota"
                            titleScan="Escanear Nota Fiscal"
                            typeInputMode="numeric"
                            @displayScanFunction="buscarChaveNota"
                            :enterKey="(e) => buscarChaveNota(e.target.value)"
                            idInput="notaInput"
                            :errorMessage="this.error"
                        >
                        </InputDefaultApp>

                        <div class="border rounded p-1 w-100 mt-2 text-center">

                            <div class="form-row">
                                <div class="col-6 text-center">
                                    <Interruptor
                                        idInput="validade"
                                        actionName="Validade">
                                    </Interruptor>
                                </div>
                                <div class="col-6 text-center">
                                    <Interruptor
                                        idInput="reversa"
                                        actionName="Reversa">
                                    </Interruptor> 
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-2" v-if="this.retorno">
            <div class="col-md-6 m-auto mt-5 small">
                <div class="card small">
                    <div class="card-header text-white p-1" :style="{ backgroundColor: moduloAtual().color }">
                        Primeira Conferência
                        <div v-show="carregando" class="spinner-grow">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    <div class="card-body p-1">
                        <div class="btn-group w-100 text-center">
                            <span class="font-weight-bold ml-3">{{ retorno.fantasia }} - {{ retorno.idclientes }}</span>
                        </div>
                        
                        <div class="btn-group w-100 text-center">
                           <span class="ml-3 font-weight-bold">
                            Número Nota Fiscal
                           </span>
                           <div class="p-0 pl-1 d-inline codigo-text pr-1 text-danger font-weight-bold ml-2 mr-5 rounded">
                                {{ retorno.numeronf }}
                            </div>
                        </div>
                        <div class="btn-group w-100 text-center">
                           <span class="text-danger ml-3 font-weight-bold">
                                {{ retorno.chavenfe }}
                           </span>
                         </div>
                        <div class="btn-group w-100 text-center font-weight-bold" v-if="this.retornoReversa">
                           <span class="ml-3" style="margin-top: 2px;">
                            Número Reversa
                           </span>
                           <div class="p-0 pl-1 d-inline codigo-text pr-1 text-black bg-warning ml-2 mr-5 rounded pt-1">
                                {{ retornoReversa.idreversas }}
                            </div>
                        </div>
                        <div class="w-100 mt-2" v-if="this.reversa && !this.retornoReversa">

                            <InputDefaultApp
                                inputPlaceHolderSufixo="Digite o número da reversa"
                                titleScan="Escanear Reversa"
                                typeInputMode="numeric"
                                @displayScanFunction="buscarReversa"
                                :enterKey="(e) => buscarReversa(e.target.value)"
                                idInput="reversaInput"
                                :errorMessage="this.errorGeral"
                            >
                            </InputDefaultApp>
                        </div>

                        <div class="mt-2" v-if="(this.retornoReversa && this.reversa) ||  (this.retorno && !this.reversa)">
                            <InputDefaultApp
                                inputPlaceHolderSufixo="Digite o código do produto"
                                titleScan="Escanear Produto"
                                typeInputMode="numeric"
                                @displayScanFunction="addConferencia"
                                :enterKey="(e) => addConferencia(e.target.value, 1)"
                                idInput="produtoInput"
                                :errorMessage="this.errorGeral"
                            >
                            </InputDefaultApp>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="mt-1" v-if="this.retorno">
            <div class="col-md-6 m-auto mt-5 small">
                <div class="card small">
                    <div class="card-body p-1">
                        <div class="w-100 text-center">
                            <span class="font-weight-bold text-danger">QTD LIDA</span>
                            <span class="ml-3">
                                    <span id="quantidadeLida">0</span> / <span id="quantidadeNota">0</span>
                            </span>
                            <span class="font-weight-bold text-danger ml-4">GIRO</span>
                            <span class="ml-3">
                            <span id="estoqueDeGiroTotal">0</span> / <span id="estoqueDeGiro">0</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-1" v-if="this.retorno">
            <div class="col-md-6 m-auto mt-5 small">
                <div class="btn-group w-100">
                    <button class="btn btn-primary btn-sm btn-block" @click="Acoes">
                        Ações
                        <em class="fa fa-align-justify ml-2"></em>
                    </button>
                </div>
            </div>
        </div>
        <div class="mt-1" v-if="this.produtoBipado">
            <div class="col-md-6 m-auto mt-5 small">
                <div class="card small p-0 border-0">
                    <div class="card-body p-0 border-0">

                        <div class="border p-2 text-left rounded pb-1">
                            <span class="font-weight-bold text-danger">
                                {{ produtoBipado.produto.descricao.length > 42 ?  produtoBipado.produto.descricao.substring(0, 42) + "..." : produtoBipado.produto.descricao}}
                            </span>
                            <div class="border-top mt-1 mb-1"></div>
                            <span class="font-weight-bold">
                                Produto:
                            </span>
                            <span class="ml-2">{{ produtoBipado.produto.codbarras }}</span>
                            <br>
                            <span class="font-weight-bold">
                                SKU:
                            </span>
                            <span class="ml-2">{{ produtoBipado.produto.sku }}</span>
                            <br>
                            <span class="font-weight-bold">
                                Possui Validade:
                            </span>
                            <span class="ml-2">[{{ produtoBipado.possuivalidade !== undefined ? produtoBipado.possuivalidade : produtoBipado.produto.possuivalidade }}]</span>
                            <br>
                            <span class="font-weight-bold">
                                Lote / Validade:
                            </span>
                            <span class="ml-2" v-if="produtoBipado.lote">[{{ produtoBipado.lote }}] - [{{ dateFormat(produtoBipado.validade) }}]</span>
                            <br>
                            <span class="font-weight-bold">
                                Quantidade:
                            </span>
                            <span class="ml-2">{{ produtoBipado.qtdeconf1 }} / {{ produtoBipado.qtde }}</span>
                            <br>
                            <span class="font-weight-bold">
                                Fator QTD:
                            </span>
                            <span class="ml-2">{{ produtoBipado.produto.fatorqtde }}</span>
                            <br>
                            <span class="font-weight-bold">
                                Shelf Life:
                            </span>
                            <span class="ml-2">{{ produtoBipado.produto.shelflife }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-5 text-center text-secondary" v-if="!this.retorno">
            <em class="fa fa-info-circle fa-3x mb-2"></em>
            <br>
            <span class="small">Bipe a chave da nota fiscal!</span>
        </div>

        <LogoutModal />
        <Modal
            id="modalOpicoesBuscaNota"
            title="Iniciar 1º Conferência"
            :confirmFunction="() => buscarChaveNotaAltomatico()"
            :cancelFunction="removeChaveUrl"
        >
            <div class="border rounded p-1 w-100 mt-2 text-center">
                <div class="form-row">
                    <div class="col-6 text-center">
                        <Interruptor
                            idInput="obrigarValidadeModal"
                            actionName="Validade">
                        </Interruptor>
                    </div>
                    <div class="col-6 text-center">
                        <Interruptor
                            idInput="associarReversaModal"
                            actionName="Reversa">
                        </Interruptor> 
                    </div>
                </div>
            </div>
        </Modal>

        <Modal
            id="modalConfirmarUltrapassagem"
            title="Confirme"
            :confirmFunction="() => confirmarUltrapassagem()"
            :cancelFunction="limparModal"
        >
            <div class="text-left">
                Quantidade da Primeira Conferência ultrapassará a quantidade da Nota Fiscal.
                <br>
                <br>
                Clique em 'Confirmar' para continuar.
            </div>
        </Modal>

        <Modal
            id="modalConfirmaAjustarQuantidade"
            title="Confirme"
            :confirmFunction="() => AjustarQuantidade('S')"
            :cancelFunction="limparModal"
        >
            <div class="text-left">
                Quantidade da Primeira Conferência ultrapassará a quantidade da Nota Fiscal.
                <br>
                <br>
                Clique em 'Confirmar' para continuar.
            </div>
        </Modal>

        <Modal
            id="modalLoteValidade"
            title="LOTE/VALIDADE"
            :confirmFunction="() => informarLoteValidade()"
            :cancelFunction="limparModal"
        >
            <div class="small text-danger" v-if="this.errorLoteValidade">{{ this.errorLoteValidade }}</div>
            <div class="text-left small">
                <div class="row">
                    <div class="col-12">
                        <label for="loteModal">* Lote</label>
                        <input inputmode="text" type="text" id="loteModal" autofocus="on" class="form-control form-control-sm" placeholder="lote" autocomplete="off">
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-12">
                        <label for="validadeModal">* Validade</label>
                        <CustomDateInput v-model="dateValue" idInput="validadeModal" />
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-5">
                        <label for="quantidadeModal">* Qtde Nota (<span id="qtdeNotaSpanModal">0</span>)</label>
                        <input inputmode="number" type="number" id="quantidadeModal" min="0" value="" class="form-control form-control-sm" autocomplete="off">
                    </div>
                    <div class="col-7 text-center pt-2">
                        <Interruptor
                            idInput="loteValidadeInserirInterruptor"
                            actionName="Possui Validade"
                            @toggle-change="changeSemLoteInserirLoteValidade">
                        </Interruptor>
                    </div>
                </div>
            </div>
        </Modal>

        <Modal
            id="modalAjustarQuantidade"
            title="Inserir Quantidade"
            :confirmFunction="() => AjustarQuantidade('N')"
            :cancelFunction="() => onModalClosed()"
        >
           <input
           inputmode="number"
           type="number"
           step="1"
           id="quantidadeAjustar"
           class="form-control form-control-sm"
           value="1"
           min="0"
           autocomplete="off"
           @keydown="(e) => { if (e.key === '.' || e.key === ',') { e.preventDefault(); }}">
        </Modal>

        <Modal
            id="modalLoteValidadeSelect"
            title="SELECIONE"
            :confirmFunction="() => selecionarLoteValidade()"
            :cancelFunction="() => onModalClosed()"
        >
            <label for="loteSelecionar">LOTE/VALIDADE</label>
            <select id="loteSelecionar" class="form-control form-control-sm mb-2">
                <option :value="item.lote + ';' + item.validade" v-for="(item) in this.loteValidadeList" :key="item.iddocumentos_has_produtos">
                    {{ item.lote }} - {{ dateFormat(item.validade) }}
                </option>
            </select>
        </Modal>

        <Modal
            id="modalAjustarLoteValidade"
            title="AJUSTAR LOTE/VAL."
            :confirmFunction="() => ajustarLoteValidade()"
            :cancelFunction="() => onModalClosed()"
        >
            <div class="small text-left">

                <div v-if="this.errorGeral" class="alert alert-warning">
                    {{  this.errorGeral }}
                </div>

                <select id="loteSelecionarAjustar" class="form-control form-control-sm mb-2">
                    <option :value="item.lote + ';' + item.validade" v-for="(item) in this.loteValidadeList" :key="item.iddocumentos_has_produtos">
                        {{ item.lote }} - {{ dateFormat(item.validade) }}
                    </option>
                </select>
                <hr>
                <div class="row">
                    <div class="col-12">
                        <label for="loteAjustarInput">* LOTE</label>
                        <input type="text" placeholder="Lote" class="form-control form-control-sm" id="loteAjustarInput">
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-5">
                        <label for="validadeAjustarInput">* DATA VAL.</label>
                        <CustomDateInput v-model="dateValueModal" idInput="validadeAjustarInput" />
                    </div>
                    <div class="col-7 pt-2 text-center">
                        <Interruptor
                            idInput="loteInterruptorAjustarLoteValidade"
                            actionName="Possui Validade"
                            :value="interruptorLigado"
                            @toggle-change="changeSemLoteAjustarLoteValidade">
                        </Interruptor>
                    </div>
                </div>
                
                <br>
                
            </div>
            
        </Modal>

        <Modal
        id="modalEditarProduto"
        title="Editar Produto"
        :cancelFunction="() => limparModalEditarProduto()"
        :confirmFunction="() => editarProduto()">

        <div class="small">
            <InputDefaultApp
                inputPlaceHolderSufixo="Digite o produto"
                titleScan="Escanear Produto"
                typeInputMode="numeric"
                @displayScanFunction="buscarProduto"
                :enterKey="(e) => buscarProduto(e.target.value)"
                idInput="produtoInputModal"
                :errorMessage="this.errorEditarProduto"
            >
            </InputDefaultApp>
        </div>
        

        <div class="card mb-2">
            <div class="card-header small p-1">
                PRODUTO
            </div>
            <div class="card-body p-1 text-left text-danger small">
                <span class="small" v-if="produtoEditarReferencia">
                    {{ this.produtoEditarReferencia.descricao.length > 40 ? this.produtoEditarReferencia.descricao.substring(0, 40) + "..." : this.produtoEditarReferencia.descricao }}
                </span>
            </div>
            
        </div>

        <div class="border p-2 rounded w-100">
            <Interruptor
                idInput="possuiValidadeModalInput"
                actionName="Possui Validade"
                :value="interruptorLigado">
            </Interruptor> 
        </div>
        
        </Modal>

        <Modal
        id="modalQuebrarLoteValidade"
        title="Incluir Lote"
        :cancelFunction="() => closeModal('modalQuebrarLoteValidade')"
        :confirmFunction="() => quebrarLoteValidade()"
        >
            <div v-if="this.errorGeral" class="alert alert-warning">
                {{  this.errorGeral }}
            </div>
            <div class="text-left small">

                <div class="row">
                    <div class="col-12">
                        <label for="lotesValidadeProduto">LOTE/VALIDADE REFERÊNCIA</label>
                        <select id="lotesValidadeProduto" class="form-control form-control-sm mb-2">

                            <option :value="item.lote + ';' + item.validade + ';' + item.qtde" v-for="(item) in this.loteValidadeList" :key="item.iddocumentos_has_produtos">
                                {{ item.lote }} - {{ dateFormat(item.validade).replace("00/00/0000", "SEM DATA") }} | QTDE: {{ item.qtde }}
                            </option>

                        </select>
                    </div>
                    <div class="col-12">
                        <label for="novoLoteModalInput">NOVO LOTE</label>
                        <input
                            id="novoLoteModalInput"
                            type="text"
                            autocomplete="off"
                            class="form-control form-control-sm mb-2"
                            placeholder="Informe o Lote"
                            inputmode="text">
                    </div>
                    <div class="col-12">
                        <label for="novaValidadeModalInput">* DATA VALIDADE</label>
                        <CustomDateInput v-model="dateValueModalQuebrar" idInput="novaValidadeModalInput" />
                    </div>

                    <div class="col-7">
                        <label class="mt-2" for="quantidadeQuebrar">QUANTIDADE</label>
                        <input
                            id="quantidadeQuebrar"
                            type="number"
                            class="form-control form-control-sm"
                            inputmode="numeric"
                            placeholder="Quantidade lote"
                            min="0"
                            @keydown="bloquearMenos">
                    </div>
                    <div class="col-5 pt-4 text-center">
                        <Interruptor
                            idInput="loteInterruptorQuebrarLoteValidade"
                            actionName="Possui Validade"
                            :value="interruptorLigado"
                            @toggle-change="changeSemLoteQuebrarLoteValidade">
                        </Interruptor>
                    </div>
                </div>
            </div>
        </Modal>

        <Modal
            id="modalZerarConferencia"
            title="Confirme:"
            :cancelFunction="() => closeModal('modalZerarConferencia')"
            :confirmFunction="() => zerarConferencia()"
            confirmText="Sim"
            cancelText="Não"
            >
            <span>Deseja realmente zerar a conferência do produto?</span>
        </Modal>

        <Modal
            id="modalAcoes"
            title="Ações"
            :buttonList="[]"
            :noFooter="true"
            :cancelFunction="focusProduto"
        >
            <button v-if="this.mostrarBotoesAcao" class="btn btn-info btn-sm btn-block m-1" @click="modalAjustarQuantidade">
                Inserir Quantidade
                <em class="fa fa-edit ml-2"></em>
           </button>
           <button v-if="this.mostrarBotoesAcao" class="btn btn-success btn-sm btn-block text-white m-1" @click="showModalQuebrarLoteValidade">
                Incluir Lote/Validade
                <em class="fa fa-wrench ml-2"></em>
           </button>
           <button v-if="this.mostrarBotoesAcao" class="btn btn-secondary btn-sm btn-block m-1" @click="modalSelecionarLoteValidade">
                Selecionar Lote/Validade
                <em class="fa fa-calendar ml-2"></em>
           </button>
           <button  v-if="this.mostrarBotoesAcao" class="btn btn-warning btn-sm btn-block text-white m-1" @click="showModalZerarConferencia">
                Zerar Conferência Produto
                <em class="fa fa-undo ml-2"></em>
           </button>
           <button class="btn btn-primary btn-sm btn-block m-1" @click="NovaConferencia">
                Nova Conferência
                <em class="fa fa-plus-circle ml-2"></em>
           </button>
           <button class="btn btn-danger btn-sm btn-block m-1" @click="closeModal('modalAcoes')">
                Sair
                <em class="fa fa-times ml-2"></em>
           </button>
        </Modal>
        <Modal
            id="modalInputCubagem"
            title="Cubagem do Produto:"
            :confirmFunction="() => salvarCubagem()"
            confirmText="Salvar Cubagem"
            cancelText="Cancelar"
            >
                <div class="alert alert-danger" v-if="cubagemError">
                    {{ cubagemError }}
                </div>

                <div class="row text-left mt-2">
                    <div class="col-12">
                        <label for="pesoCubagem">Peso(g)</label>
                        <input
                            type="number"
                            id="pesoCubagem"
                            class="form-control form-control-sm"
                            onclick="document.getElementById('pesoCubagem').select()"
                            min="0">
                    </div>
                    <div class="col-12">
                        <label for="comprimento">Comprimento(cm)</label>
                        <input
                            type="number"
                            id="comprimento"
                            class="form-control form-control-sm"
                            onclick="document.getElementById('comprimento').select()">
                    </div>
                    <div class="col-12">
                        <label for="largura">Largura(cm)</label>
                        <input
                            type="number"
                            id="largura"
                            class="form-control form-control-sm"
                            onclick="document.getElementById('largura').select()"
                            >
                    </div>
                    <div class="col-12">
                        <label for="altura">Altura(cm)</label>
                        <input
                            type="number"
                            id="altura"
                            class="form-control form-control-sm"
                            onclick="document.getElementById('altura').select()">
                    </div>
                </div>
        </Modal>
        <FooterBar />
    </div>
</template>
  
<script>
  // @ is an alias to /src
  import Topbar from '@/components/Topbar.vue'
  import FooterBar from '@/components/FooterBar.vue'
  import LogoutModal from '@/components/LogoutModal.vue'
  import Interruptor from '@/components/Interruptor.vue'
  import Modal from "../components/Modal.vue";
  import CustomDateInput from '../components/CustomDateInput.vue';
  import InputDefaultApp from '../components/InputDefaultApp.vue';
  import ViewMixin from './ViewMixin'
  import { DEFAULT_ERROR_MESSAGE, ServerErrorException, TokenInvalidoException } from '../services/exceptions'
  import api, { getUserId, getUsername, getPerfil } from '../services/api'
  import $ from "jquery";
  import { dateFormat } from '../utils';
  import audioService from '@/services/audioService.js';

  export default {
    name: 'Categoria',
    mixins: [
      ViewMixin
    ],
    components: {
      Topbar,
      LogoutModal,
      FooterBar,
      Modal,
      CustomDateInput,
      InputDefaultApp,
      Interruptor,
    },
  
    data: () => {
      return {
        menus : [],
        selecionarLoteEBipar: false,
        errorGeral: null,
        primeiroBip: true,
        command: "novo",
        chaveNotaReferencia: null,
        retorno: null,
        error: null,
        loteReferencia: null,
        validadeReferencia: null,
        obrigarValidade: false,
        reversa: false,
        retornoReversa: null,
        serialInformado: "N",
        idDocumentoProdutoReferencia: null,
        produtoCodigoBarrasReferencia: null,
        errorLoteValidade: null,
        produtoReferencia: {
            produto: {
                possuivalidade: "N"
            }
        },
        produtoEditarReferencia: null,
        mostrarBotoesAcao: false,
        produtoBipado: null,
        produtosBipado: [],
        loteValidadeList: [],
        dateValue: '',
        dateValueModal: '',
        dateValueModalQuebrar: '',
        ultrapassaPrimeiraConferencia: 'N',
        interruptorLigado: false,
        errorEditarProduto: '',
        produtosNaoObrigarLoteValidade: [],
        produtoCubagem: null,
        cubagemError: null
      };
    },
  
    async mounted() {

        let self = this;

        try {
            await this.validarToken();
        } catch (e) {
                if (e instanceof TokenInvalidoException) {
                this.handleTokenInvalidoException();
            } else if (e instanceof ServerErrorException) {
                alert(e.message);
            } else {
                alert(DEFAULT_ERROR_MESSAGE);
            }      
        }

        let hash = window.location.hash;

        // Verifica se existe um "?" após o hash (indicando que há parâmetros)
        if (hash.includes('?')) {
            let queryString = hash.split('?')[1];
            let urlParams = new URLSearchParams(queryString);
            let chave = urlParams.get('chave');

            if (chave !== null && chave !== undefined) {
                $('#modalOpicoesBuscaNota').modal('show');
            }
        }

        setTimeout(() => {
            document.getElementById('notaInput').focus();
            document.getElementById('notaInput').select();
        }, 1000);

        document.getElementById("reversa").addEventListener('change', function(){
            setTimeout(() => {
                $("#notaInput").select();
                $("#notaInput").focus();
            }, 250);
        });

        document.getElementById("validade").addEventListener('change', function(){
            setTimeout(() => {
                $("#notaInput").select();
                $("#notaInput").focus();
            }, 250);
        });

        document.getElementById("lotesValidadeProduto").addEventListener('change', function(){
            let arr = $("#lotesValidadeProduto").val().split(";");
            let lote = arr[0];
            let validade = arr[1];
            let qtde = arr[2];

            if (lote !== "SEM LOTE") {
                $("#novoLoteModalInput").val(lote);
                $("#novaValidadeModalInput").val(dateFormat(validade));
                $("#quantidadeQuebrar").val(qtde);
                self.dateValueModalQuebrar = validade;
                
            } else {
                $("#novoLoteModalInput").val("");
                self.dateValueModalQuebrar = "";
                $("#quantidadeQuebrar").val("");
                $("#novaValidadeModalInput").val("");
            }
        });
    },
  
    methods: {
        getUsername,
        getPerfil,
        dateFormat,

        playSound() {
            audioService.ops();
        },

        closeModal(modalId) {
            $('#'+modalId).modal('hide');
            this.onModalClosed();
        },

        bloquearMenos(event) {
            if (event.key === '-' || event.key === 'Minus') {
                event.preventDefault();
            }
        },

        buscarChaveNotaAltomatico() {
            let hash = window.location.hash;
            let queryString = hash.split('?')[1];
            let urlParams = new URLSearchParams(queryString);
            let chave = urlParams.get('chave');

            document.getElementById('notaInput').value = chave;
            this.chaveNotaReferencia = chave;
            this.obrigarValidade = document.getElementById('obrigarValidadeModal').checked;
            this.reversa = document.getElementById('associarReversaModal').checked;
            this.consultar();

            this.closeModal('modalOpicoesBuscaNota');
        },

        removeChaveUrl() {
            this.$router.replace({ path: '/primeiraconferencia' });
        },

        onModalClosed() {
            let produtoInput = document.getElementById("produtoInput");
            let reversaInput = document.getElementById("produtoInput");

            if (produtoInput !== null && produtoInput !== undefined) {
                this.focusProduto();
            }
            if (reversaInput !== null && reversaInput !== undefined) {
                this.focusReversa();
            }
        },

        clearInputs() {
            $("#reversaInput").css("border", "1px solid #CCC");
            $("#produtoInput").css("border", "1px solid #CCC");
        },

        displayErrorInput(id) {
            $("#"+id).css("border", "1px solid red");
        },

        async validarToken() {
            this.carregando = true;
    
            await api.get("/validar-token");
    
            this.carregando = false;
        },

        Acoes() {
            $("#modalAcoes").modal("show");
        },

        NovaConferencia() {
            this.clearInputs();
            this.errorGeral = null;
            this.retorno = null;
            this.limparModal();
            $("#modalAcoes").modal("hide");
            this.chaveNotaReferencia= null;
            this.retorno= null;
            this.retornoReversa = null;
            this.error= null;
            this.loteReferencia= null;
            this.validadeReferencia= null;
            this.obrigarValidade= false;
            this.reversa= false;
            this.serialInformado= "N";
            this.idDocumentoProdutoReferencia= null;
            this.produtoCodigoBarrasReferencia= null;
            this.errorLoteValidade= null;
            this.produtoReferencia= null;
            this.mostrarBotoesAcao = false;
            this.produtosBipado = [];
            this.produtoBipado = null;
            this.ultrapassaPrimeiraConferencia = "N";
            this.primeiroBip = true;
            
            if (document.getElementById('reversaInput') !== null) {
                $('#reversaInput').val('');
            }

            setTimeout(() => {
                $("#notaInput").focus();
                $('#notaInput').select();
            }, 500);
        },

        buscarChaveNota(value) {
            if (value.trim() !== "" && value.trim().length == 44) {
                this.chaveNotaReferencia = value;
                this.obrigarValidade = document.getElementById('validade').checked;
                this.reversa = document.getElementById('reversa').checked;
                this.consultar();
            } else {
                this.playSound();
                this.error = "A chave da nota precisa ter 44 caracteres!";
                let notaInput = document.getElementById('notaInput');
                notaInput.focus();
                notaInput.select();
            }
        },

        async consultar() {

            this.carregando = true;
            try {

                let validadeInput = document.getElementById('validade');
                let reversaInput  = document.getElementById('reversa');

                let body = {
                    reversa: reversaInput.checked ? "reversa" : "N",
                    validade: validadeInput.checked ? "validade" : "N",
                    chave: this.chaveNotaReferencia,
                    idUsuario: getUserId()
                };
                let response = await api.post(`/inbound/primeiraconferencia/nota`, body);
                this.retorno = response.data;

                if (this.retorno.idreversas !== null) {
                    this.retorno.ativarReversa = "S";
                    $("#reversa").prop("checked", true);
                    this.buscarReversa(this.retorno.idreversas);
                }

                if (this.retorno.ativarReversa == "S") {
                    this.focusReversa();
                } else {
                    this.focusProduto();
                }

                this.error = null;
            } catch(e) {
                this.error = e.message;
                this.retorno = null;

                let notaInput = document.getElementById('notaInput');
                notaInput.focus();
                notaInput.select();
                this.playSound();
            }

            let notaInput = document.getElementById('notaInput');
            notaInput.focus();
            notaInput.select();

            this.carregando = false;
        },


        async inputCubagem(codigoBarras, quantidade) {
            try {
                $("#modalInputCubagem").modal('show');
                let result = await api.post(`/inbound/produto`, {
                        codigoBarras: codigoBarras
                });

                if (result.data.produto) {
                    this.produtoCubagem = result.data.produto;
                    this.produtoCubagem["quantidade"] = quantidade;
                }
            } catch (e) {
                this.displayErrorInput('produtoInput');
                this.errorGeral = e.message;
                this.playSound();
                this.closeModal("modalInputCubagem");
            }
        },

        validar() {
                
            if ($("#pesoCubagem").val() <= 0) {
                this.cubagemError = "Peso não pode ser menor ou igual a zero!";
                $("#pesoCubagem").val("");
                $("#pesoCubagem").focus();
                return false;
            }

            if ($("#comprimento").val() <= 0) {
                this.cubagemError = "Comprimento não pode ser menor ou igual a zero!";
                $("#comprimento").val("");
                $("#comprimento").focus();
                return false;
            }

            if ($("#largura").val() <= 0) {
                this.cubagemError = "Largura não pode ser menor ou igual a zero!";
                $("#largura").val("");
                $("#largura").focus();
                return false;
            }

            if ($("#altura").val() <= 0) {
                this.cubagemError = "Altura não pode ser menor ou igual a zero!";
                $("#altura").val("");
                $("#altura").focus();
                return false;
            }

            return true;
        },

        async salvarCubagem() {

            if (!this.validar()) {
                this.playSound();
                return;
            }

            this.closeModal("modalInputCubagem");

            try {
                let result = await api.post(`/inbound/salvarcubagem`, {
                    peso: $("#pesoCubagem").val(),
                    comprimento: $("#comprimento").val(),
                    largura: $("#largura").val(),
                    altura: $("#altura").val(),
                    idProduto: this.produtoCubagem.idprodutos,
                    idUsuario: getUserId(),
                });

                if (result.data.updated) {
                    this.addConferencia(this.produtoCubagem.codbarras, this.produtoCubagem.quantidade);
                }
            } catch (error) {
                this.displayErrorInput('produtoInput');
                this.errorGeral = error.message;
                this.playSound();
            }
        },

        async addConferencia(codigoBarras, quantidade) {
            this.errorGeral = null;

            try {
                let cubagem = await api.post("/inbound/getcubagem", {
                    codigoBarras: codigoBarras
                });

                if(cubagem.data.semcubagem && codigoBarras != "") {
                    this.inputCubagem(codigoBarras, quantidade);
                    return;
                }
            } catch (e) {
                this.displayErrorInput('produtoInput');
                this.errorGeral = e.message;
                this.playSound();
                return;
            }

            if (quantidade === null) {
                quantidade = 1;
            }

            this.clearInputs();
            if (codigoBarras !== this.produtoCodigoBarrasReferencia) {
                this.loteReferencia = null;
                this.validadeReferencia = null;
                this.idDocumentoProdutoReferencia = null;
            }

            this.carregando = true;

            let produtoInput = document.getElementById('produtoInput');
            produtoInput.select();
            produtoInput.focus();

            try {

                this.produtoCodigoBarrasReferencia = codigoBarras;

                let body = {
                    chave: this.chaveNotaReferencia,
                    codigoBarras: codigoBarras,
                    serialInformado: this.serialInformado,
                    ultrapassaPrimeiraConferencia: this.ultrapassaPrimeiraConferencia,
                    obrigarValidade: this.obrigarValidade && !this.produtosNaoObrigarLoteValidade.includes(codigoBarras) ? "S" : "N",
                    quantidade: quantidade,
                    idDocumentoProduto: this.idDocumentoProdutoReferencia,
                    lote: this.loteReferencia,
                    validade: this.validadeReferencia,
                    idUsuario: getUserId()
                };

                let response = await api.post("/inbound/primeiraconferencia/add", body);

                if (JSON.stringify(response.data).includes("command")) {
                    this.mostrarBotoesAcao = true;

                    this.produtoReferencia = response.data.produtoNotafiscal;
                    if (response.data.command === "informar_lotevalidade") {
                        this.mostrarBotoesAcao = false;
                        this.buscarLoteValidade(true);
                        
                        setTimeout(() => { 
                            let loteInput = document.getElementById('loteModal');
                            loteInput.focus();
                            loteInput.select();
                        }, 1000);
                    } else if (response.data.command === "informar_serial") {
                        $("#modalSerial").modal('show');
                        setTimeout(() => {
                            $("#serialNumberInput").val("");
                            $("#serialNumberInput").focus();
                            $("#serialNumberInput").select();
                        }, 500);
                    }
                } else {
                    this.produtoReferencia = response.data;
                    this.listarProdutos(response.data);
                    this.serialInformado = "N";
                    this.primeiroBip = false;
                }
            } catch (e) {

                if (e.message.includes("Quantidade da Primeira Conferência ultrapassará a quantidade da Nota Fiscal. Clique em 'Confirmar' para continuar.")){
                    $('#modalConfirmarUltrapassagem').modal('show');
                } else {
                    this.displayErrorInput('produtoInput');
                    this.errorGeral = e.message;
                    this.playSound();
                }
            }

            this.carregando = false;
        },

        confirmarUltrapassagem() {
            this.closeModal('modalConfirmarUltrapassagem');
            this.ultrapassaPrimeiraConferencia = "S";
            if (this.primeiroBip) {
                this.idDocumentoProdutoReferencia = null;
            }
            let quantidade = this.selecionarLoteEBipar ? 1 : 0;
            this.addConferencia(this.produtoCodigoBarrasReferencia, quantidade);
        },

        incluirLoteValidade() {
            this.errorGeral = null;
            this.command = "incluir";
            $("#modalAcoes").modal("hide");
            $("#modalLoteValidade").modal('show');

            let possuiLoteValidade = this.produtoReferencia.possuivalidade !== undefined ? this.produtoReferencia.possuivalidade === "S" : this.produtoReferencia.produto.possuivalidade === "S";

            $("#loteValidadeInserirInterruptor").prop("checked", possuiLoteValidade);
            this.interruptorLigado = possuiLoteValidade;

            this.changeSemLoteInserirLoteValidade();
            $("#qtdeNotaSpanModal").text(this.produtoReferencia.qtde);
            
            let loteInput = document.getElementById('loteModal');
            let validadeInput = document.getElementById('validadeModal');
            let quantidadeInput = document.getElementById('quantidadeModal');

            loteInput.value = "";
            validadeInput.value = "";
            quantidadeInput.value = "";

            loteInput.setAttribute('style', '');
            validadeInput.setAttribute('style', '');
            quantidadeInput.setAttribute('style', '');
            this.errorLoteValidade = null;
            
            loteInput.focus();

            setTimeout(() => { 
                let loteInput = document.getElementById('loteModal');
                loteInput.focus();
                loteInput.select();
            }, 1000);
        },

        listarProdutos(produtoNotafiscal) {
            this.errorGeral = null;
            this.clearInputs();
            this.mostrarBotoesAcao = true;

            if (this.produtosBipado.length === 0) {
                this.produtosBipado.push(produtoNotafiscal);
            } else {
                let existe = false;

                for (let p of this.produtosBipado) {

                    if (p.produtos_idprodutos=== produtoNotafiscal.produtos_idprodutos
                    && p.lote === produtoNotafiscal.lote
                    && p.validade ===  produtoNotafiscal.validade) {

                        p["qtdeconf1"] = produtoNotafiscal.qtdeconf1;
                        existe = true;
                        break;
                    }
                }

                if (!existe) {
                    this.produtosBipado.push(produtoNotafiscal);
                }
            }

            let quantidadeProdutoLinha = document.getElementById('td_'+produtoNotafiscal.produto.codbarras);

            let quantidadeLidaSpan = document.getElementById('quantidadeLida');
            let quantidadeNotaSpan = document.getElementById('quantidadeNota');

            let estoqueDeGiroSpan = document.getElementById('estoqueDeGiro');
            let estoqueDeGiroTotalSpan = document.getElementById('estoqueDeGiroTotal');

            quantidadeLidaSpan.innerText = produtoNotafiscal.qtdeconf1;
            quantidadeNotaSpan.innerText = produtoNotafiscal.qtde;

            if (quantidadeProdutoLinha !== null && quantidadeProdutoLinha != undefined) {
                quantidadeProdutoLinha.innerHTML =  produtoNotafiscal.qtdeconf1;
            }

            estoqueDeGiroSpan.innerText =  produtoNotafiscal.qtde;
            estoqueDeGiroTotalSpan.innerText = produtoNotafiscal.qtde_estoque !== null &&  produtoNotafiscal.qtde_estoque !== undefined ? produtoNotafiscal.qtde_estoque : 0;
            this.produtoBipado = produtoNotafiscal;
        },

        focusProduto() {
            setTimeout(() => { 
                let produtoInput = document.getElementById('produtoInput');

                if (produtoInput !== null) {
                    produtoInput.select();
                    produtoInput.focus();
                }
            }, 1000);
        },

        focusReversa() {
            setTimeout(() => { 
                let reversaInput = document.getElementById('reversaInput');

                if (reversaInput !== null) {
                    reversaInput.select();
                    reversaInput.focus();
                }
            }, 1000);
        },

        limparModal() {
            let loteInput = document.getElementById('loteModal');
            let quantidadeInput = document.getElementById('quantidadeModal');

            loteInput.value = "";
            this.dateValue = "";
            quantidadeInput.value = "";
            
            loteInput.setAttribute('style', '');
            quantidadeInput.setAttribute('style', '');
            this.errorLoteValidade = null;

            this.focusProduto();
        },

        isValidDate(dateString) {
            // Verifica se o formato é válido: yyyy-mm-dd
            const regex = /^\d{4}-\d{2}-\d{2}$/;
            if (!dateString.match(regex)) {
                return false;
            }

            // Desestrutura o ano, mês e dia
            const [year, month, day] = dateString.split('-').map(Number);

            // Verifica se a data existe no calendário
            const date = new Date(year, month - 1, day);  // Lembre-se: meses em JavaScript vão de 0 a 11
            
            return date.getFullYear() === year &&
            date.getMonth() === month - 1 &&
            date.getDate() === day;
        },

        async informarLoteValidade() {
            let loteInput = document.getElementById('loteModal');
            let validadeInput = document.getElementById('validadeModal');
            let quantidadeInput = document.getElementById('quantidadeModal');

            let possuiLoteValidade = $("#loteValidadeInserirInterruptor").prop("checked");

            if (loteInput.value.trim() === "" && possuiLoteValidade) {
                this.errorLoteValidade = "Informe o lote!";
                loteInput.setAttribute('style', 'border: 1px solid red');
                return;
            }

            if (this.dateValue.trim() === "" && possuiLoteValidade) {
                this.errorLoteValidade = "Informe a data de validade!";
                validadeInput.setAttribute('style', 'border: 1px solid red');
                validadeInput.focus();
                validadeInput.select();
                return;
            }

            if (!this.isValidDate(this.dateValue) && possuiLoteValidade) {
                this.errorLoteValidade = "Data inválida!";
                validadeInput.setAttribute('style', 'border: 1px solid red');
                validadeInput.focus();
                validadeInput.select();
                return;
            }

            if ((quantidadeInput.value.trim() === "" || quantidadeInput.value.trim() === "0")  && possuiLoteValidade) {
                this.errorLoteValidade = "Informe a quantidade maior que 0!";
                quantidadeInput.setAttribute('style', 'border: 1px solid red');
                return;
            }

            if (!possuiLoteValidade) {
                try {
                    this.produtosNaoObrigarLoteValidade.push(this.produtoCodigoBarrasReferencia);
                    await api.post('/inbound/primeiraconferencia/editarproduto', {
                        chave: this.chaveNotaReferencia,
                        codigoBarras: this.produtoCodigoBarrasReferencia,
                        possuiValidade: "N",
                        idUsuario: getUserId()
                    });

                    this.addConferencia(this.produtoCodigoBarrasReferencia, 1);
                    this.listarProdutos(this.produtoReferencia);

                    this.idDocumentoProdutoReferencia = this.produtoReferencia.iddocumentos_has_produtos;
                    this.loteReferencia = this.produtoReferencia.lote;
                    this.validadeReferencia = this.produtoReferencia.validade;

                    this.closeModal('modalLoteValidade');
                    this.limparModal();
                    this.primeiroBip = false;
                } catch (e) {
                    this.displayErrorInput('reversaInput');
                    this.errorGeral = e.message;
                    this.playSound();
                }

                this.carregando = false;
                return;
            }

            loteInput.setAttribute('style', '');
            validadeInput.setAttribute('style', '');
            quantidadeInput.setAttribute('style', '');
            this.errorLoteValidade = null;

            this.carregando = true;

            try {

                let response1 = await api.post('/inbound/primeiraconferencia/produto/lotevalidade', {
                    chave: this.chaveNotaReferencia,
                    codigoBarras: this.produtoCodigoBarrasReferencia
                });

                this.loteValidadeList = response1.data;

                if (this.loteValidadeList.length > 0) {
                    this.command = "incluir";
                }

                this.loteReferencia = loteInput.value;
                this.validade = validadeInput.validade;

                let body = {
                    chave: this.chaveNotaReferencia,
                    command: this.command,
                    codigoBarras: this.produtoCodigoBarrasReferencia,
                    lote: loteInput.value,
                    validade: this.dateValue,
                    idProduto: this.produtoReferencia.produto.idprodutos,
                    quantidade: quantidadeInput.value,
                    idUsuario: getUserId()
                };

                let response2 = await api.post("/inbound/primeiraconferencia/addlotevalidade", body);
                this.listarProdutos(response2.data);

                this.produtoReferencia = response2.data;
                this.idDocumentoProdutoReferencia = response2.data.iddocumentos_has_produtos;
                this.loteReferencia = response2.data.lote;
                this.validadeReferencia = response2.data.validade;

                this.closeModal('modalLoteValidade');
                this.limparModal();
                this.primeiroBip = false;
            } catch (e) {
                this.errorLoteValidade =e.message;
                this.playSound();
            }

            this.carregando = false;
        },

        modalAjustarQuantidade() {
            
            $("#modalAcoes").modal("hide");
            $("#modalAjustarQuantidade").modal('show');
            $("#modalConfirmaAjustarQuantidade").modal('hide');
            
            $("#quantidadeAjustar").val(1);

            setTimeout(() => {
                $("#quantidadeAjustar").select();
                $("#quantidadeAjustar").focus();
            }, 1000);
        },

        async AjustarQuantidade(ultrapassaPrimeiraConferenciaAjuste) {
  
            this.carregando = true;

            if ($("#quantidadeAjustar").val() > this.produtoReferencia.qtde && ultrapassaPrimeiraConferenciaAjuste === 'N') {
                this.carregando = false;
                $("#modalAjustarQuantidade").modal('hide');
                $("#modalConfirmaAjustarQuantidade").modal('show');
                return;
            }

            let body = {
                chave: this.chaveNotaReferencia,
                idDocumentoHasProduto: this.produtoReferencia.iddocumentos_has_produtos,
                qtde: $("#quantidadeAjustar").val()
            };

            try {
                let response = await api.post('/inbound/primeiraconferencia/ajustarconferencia', body);
                this.listarProdutos(response.data);

                this.produtoReferencia = response.data;
                this.ultrapassaPrimeiraConferencia = "N";
            } catch (error) {
                this.errorGeral = error.message;
                this.playSound();
            }

            this.closeModal('modalAjustarQuantidade');
            this.closeModal('modalConfirmaAjustarQuantidade');
            
            this.focusProduto();
            this.carregando = false;
        },

        async buscarLoteValidade(bipado) {
            this.errorGeral = null;
            this.clearInputs();

            try {
                let response = await api.post('/inbound/primeiraconferencia/produto/lotevalidade', {
                    chave: this.chaveNotaReferencia,
                    codigoBarras: this.produtoCodigoBarrasReferencia
                });

                let existeLinhaSemLote = false;
                let listaLotes = [];
                for (const item of response.data) {
                    if (item.lote !== "SEM LOTE") {
                        listaLotes.push(item);
                    } else {
                        existeLinhaSemLote = true;
                    }
                }

                this.loteValidadeList = listaLotes;

                if (bipado) {
                    if ((response.data.length === 1 && this.primeiroBip && response.data[0].lote !== "SEM LOTE") ||
                    !existeLinhaSemLote && response.data.length > 1 && this.primeiroBip) {
                        this.idDocumentoProdutoReferencia = response.data[0].documentos_iddocumentos;
                        this.selecionarLoteEBipar = true;
                        $("#modalLoteValidadeSelect").modal('show');
                        $("#qtdeNotaSpanModal").text(this.produtoReferencia.qtde);
                    } else if (response.data.length > 1 && this.primeiroBip) {
                        $("#loteInterruptorQuebrarLoteValidade").prop("checked", true);
                        this.loteValidadeList = response.data;
                        $("#modalQuebrarLoteValidade").modal('show');
                    } else {
                        $("#modalLoteValidade").modal('show');
                        let possuiLoteValidade = this.produtoReferencia.possuivalidade !== undefined ? this.produtoReferencia.possuivalidade === "S" : this.produtoReferencia.produto.possuivalidade === "S";

                        $("#loteValidadeInserirInterruptor").prop("checked", possuiLoteValidade);
                        this.interruptorLigado = possuiLoteValidade;
                        this.changeSemLoteInserirLoteValidade();

                        $("#qtdeNotaSpanModal").text(this.produtoReferencia.qtde);
                    }
                }
            } catch (error) {
                this.errorGeral = error.message;
                this.playSound();
            }
        },

        modalSelecionarLoteValidade() {
            this.selecionarLoteEBipar = false;
            this.loteValidadeList = [];
            this.buscarLoteValidade(false);

            $("#modalAcoes").modal("hide");

            setTimeout(() => {
                if (this.loteValidadeList.length > 0) {
                    $("#modalLoteValidadeSelect").modal("show");
                    $("#qtdeNotaSpanModal").text(this.produtoReferencia.qtde);
                } else {
                    this.errorGeral = "Não há lote/validade inclusos neste produto!";
                    this.playSound();
                }
            }, 250);
        },

        async modalAjustarLoteValidade() {
            this.dateValueModal = this.produtoReferencia.validade;

            $("#modalAcoes").modal("hide");
            let response = await api.post('/inbound/primeiraconferencia/produto/lotevalidade', {
                chave: this.chaveNotaReferencia,
                codigoBarras: this.produtoCodigoBarrasReferencia
            });

            let listaLotes = [];
            for (const item of response.data) {
                if (item.lote !== "SEM LOTE") {
                    listaLotes.push(item);
                }
            }

            if (listaLotes.length > 0) {
                this.loteValidadeList = listaLotes;
                this.dateValueModal = "";

                $("#modalAjustarLoteValidade").modal("show");

                let possuiLoteValidade = this.produtoReferencia.possuivalidade !== undefined ? this.produtoReferencia.possuivalidade === "S" : this.produtoReferencia.produto.possuivalidade === "S";

                $("#loteInterruptorAjustarLoteValidade").prop("checked", possuiLoteValidade);
                this.interruptorLigado = possuiLoteValidade;
                this.changeSemLoteAjustarLoteValidade();

                
                setTimeout(() => {
                    $('#loteAjustarInput').val(this.produtoReferencia.lote);
                }, 250);
            } else {
                this.errorGeral = "Não há lote/validade inclusos neste produto!";
                this.playSound();
            }
        },

        selecionarLoteValidade() {
            this.command = "incluir";
            let loteValidade = $('#loteSelecionar').val();
            this.closeModal('modalLoteValidadeSelect');

            let explode = loteValidade.split(";");
            let lote = explode[0];
            let validade = explode[1];

            this.loteReferencia = lote;
            this.validadeReferencia = validade;

            this.produtoReferencia["lote"] = lote;
            this.produtoReferencia["validade"] = validade;

            if (this.produtoReferencia.qtdeconf1 === 0 || this.ultrapassaPrimeiraConferencia) {
                this.primeiroBip = false;
                let quantidade = this.selecionarLoteEBipar ? 1 : 0;
                this.addConferencia(this.produtoCodigoBarrasReferencia, quantidade);
            }

            this.selecionarLoteEBipar = true;
            this.focusProduto();
        },

        async ajustarLoteValidade() {
            let loteValidadeSelecionado = $('#loteSelecionarAjustar').val()
            let arr = loteValidadeSelecionado !== null ? loteValidadeSelecionado.split(";") : [];
            let lote = arr[0] !== undefined ? arr[0] : null;
            let validade = arr[1] !== undefined ? arr[1] : null;

            if ($("#loteInterruptorAjustarLoteValidade").prop("checked")) {

                if (lote === null) {
                    this.errorGeral = "Não há lote/validade inclusos neste produto!";
                    this.playSound();
                    return;
                }

                if ($('#loteAjustarInput').val().length === 0) {
                    this.errorGeral = "Insira o novo lote";
                    this.playSound();
                    return;
                }

                if (this.dateValueModal == "") {
                    this.errorGeral = "Insira o nova data de validade!";
                    this.playSound();
                    return;
                }

                try {
                    let body = {
                        chave: this.chaveNotaReferencia,
                        lote: lote,
                        validade: validade,
                        loteNovo: $('#loteAjustarInput').val(),
                        validadeNova: this.dateValueModal,
                        codigoBarras: this.produtoCodigoBarrasReferencia,
                        idUsuario: getUserId()
                    };

                    let response = await api.post("/inbound/primeiraconferencia/ajustarlotevalidade", body);

                    if (response.status == 200) {
                        this.loteReferencia = $('#loteAjustarInput').val();
                        this.validadeReferencia = this.dateValueModal;
                        this.produtoReferencia["lote"] = $('#loteAjustarInput').val();
                        this.produtoReferencia["validade"] = this.dateValueModal;

                        if ($('#loteAjustarInput').val() === "") {
                            this.idDocumentoProdutoReferencia = null;
                        }

                        this.listarProdutos(this.produtoReferencia);

                        this.closeModal('modalAjustarLoteValidade');
                    }
                } catch (e) {
                    this.errorGeral = e.message;
                    this.playSound();
                }
            } else {
                this.closeModal('modalAjustarLoteValidade');
            }

            this.focusProduto();
        },

        async insertSerialNumer() {
            this.errorGeral = null;
            this.clearInputs();

            try {
                let response = await api.post('/inbound/primeiraconferencia/serialnumber/add', {
                    chave: this.chaveNotaReferencia,
                    codigoBarras: this.produtoCodigoBarrasReferencia,
                    seriais:  $("#serialNumberInput").val()
                });

                if (JSON.stringify(response.data).includes("qtde")) {
                    this.closeModal('modalSerial');
                    this.focusProduto();
                    this.serialInformado = "S";
                    this.addConferencia(this.produtoCodigoBarrasReferencia, response.data.qtde);
                }
            } catch (error) {
                this.errorGeral = error.message;
                this.playSound();
            }
        },

        async buscarReversa(reversa) {
            this.errorGeral = null;
            this.carregando = true;
            this.clearInputs();

            try {
                let response = await api.post('/inbound/primeiraconferencia/buscarreversa', {
                    reversa: reversa,
                    idUsuario: getUserId(),
                    idDocumento: this.retorno.iddocumentos,
                    numeroNf: this.retorno.numeronf
                });

                this.retornoReversa = response.data;
                this.focusProduto();
            } catch (e) {
                this.displayErrorInput('reversaInput');
                this.errorGeral = e.message;
                this.playSound();
            }

            this.carregando = false;
        },

        showModalEditarProduto() {
            this.errorEditarProduto = null;
            $("#modalAcoes").modal("hide");
            $("#possuiValidadeModalInput").prop("checked", this.produtoReferencia.produto.possuivalidade === "S");
            $("#modalEditarProduto").modal("show");

            setTimeout(() => {
                $("#produtoInputModal").focus();
                $("#produtoInputModal").select();
            }, 500);
        },

        async buscarProduto(codigoBarras) {

            this.errorEditarProduto = null;
            this.produtoEditarReferencia = null;

            if (codigoBarras.trim() === "") {
                this.errorEditarProduto = "Informe o produto!";
                return;
            }

            try {
                let response = await api.post('/inbound/primeiraconferencia/buscarproduto', {
                    chave: this.chaveNotaReferencia,
                    codigoBarras: codigoBarras
                });

                this.produtoEditarReferencia = response.data;

                $("#possuiValidadeModalInput").prop("checked", this.produtoEditarReferencia.possuivalidade === "S");
                $("#produtoInputModal").select();
                $("#produtoInputModal").focus();
            } catch (e) {
                this.displayErrorInput('reversaInput');
                this.errorEditarProduto = e.message;
                
                document.getElementById("produtoInputModal").focus();
                document.getElementById("produtoInputModal").select();

                this.playSound();
            }
        },


        limparModalEditarProduto() {
            $("#produtoInputModal").val("");
            $("#possuiValidadeModalInput").prop("checked", false);
            this.closeModal('modalEditarProduto');
            this.produtoEditarReferencia = null;
        },

        async editarProduto() {
            let possuivalidade = $("#possuiValidadeModalInput").prop("checked") ? "S" : "N";

            if (this.produtoEditarReferencia === null || this.produtoEditarReferencia.descricao === undefined) {
                this.errorEditarProduto = "Informe o produto!";

                document.getElementById("produtoInputModal").focus();
                document.getElementById("produtoInputModal").select();

                return;
            }

            this.carregando = true;
            this.errorEditarProduto = null;

            if (possuivalidade === "N") {
                this.produtosNaoObrigarLoteValidade.push(this.produtoEditarReferencia.codbarras);
            }
            
            try {
                await api.post('/inbound/primeiraconferencia/editarproduto', {
                    chave: this.chaveNotaReferencia,
                    codigoBarras: this.produtoEditarReferencia.codbarras,
                    possuiValidade: possuivalidade,
                    idUsuario: getUserId()
                });

                $("#possuiValidadeModalInput").prop("checked", false);
                $("#produtoInputModal").val("");
                $("#modalEditarProduto").modal("hide");
            } catch (e) {
                document.getElementById("produtoInputModal").focus();
                document.getElementById("produtoInputModal").select();

                this.errorEditarProduto = e.message;
                this.playSound();              
            }

            this.carregando = false;
        },

        async showModalQuebrarLoteValidade() {
            this.errorGeral = null;
            $("#modalAcoes").modal('hide');
            $("#modalQuebrarLoteValidade").modal('show');
            $("#novoLoteModalInput").val("");
            $("#quantidadeQuebrar").val("");
            this.dateValueModal = '';

            let possuiLoteValidade = this.produtoReferencia.produto.possuivalidade !== undefined ? this.produtoReferencia.produto.possuivalidade === "S" : this.produtoReferencia.possuivalidade === "S";
            $("#loteInterruptorQuebrarLoteValidade").prop("checked", possuiLoteValidade);
            this.interruptorLigado = possuiLoteValidade;

            if (!possuiLoteValidade) {
                $("#novoLoteModalInput").prop("disabled", true);
                $("#novaValidadeModalInput").prop("disabled", true);
                $("#quantidadeQuebrar").prop("disabled", true);
            }

            this.dateValueModalQuebrar = '';

            try {
                let response = await api.post('/inbound/primeiraconferencia/produto/lotevalidade', {
                    chave: this.chaveNotaReferencia,
                    codigoBarras: this.produtoCodigoBarrasReferencia
                });

                this.loteValidadeList = response.data;
            } catch (error) {
                this.errorGeral = error.message;
                this.playSound();
            }
        },

        async quebrarLoteValidade() {
            
            let novoLote =  $("#novoLoteModalInput").val();
            let quantidade = $("#quantidadeQuebrar").val();

            if (!$("#loteInterruptorQuebrarLoteValidade").prop("checked")) {
                this.errorGeral = "Lote/Validade não Informado!";
                return;
            }

            if (novoLote === "") {
                this.errorGeral = "Novo lote não Informado!";
                return;
            }

            if (this.dateValueModalQuebrar === "") {
                this.errorGeral = "Nova validade não Informada!";
                return;
            }

            if (quantidade === "") {
                this.errorGeral = "Quantidade não Informada!";
                return;
            }

            let arr = $("#lotesValidadeProduto").val().split(";");
            let lote = arr[0];
            let validade = arr[1];

            if (lote === "SEM LOTE") {
                lote = null;
                validade = null;
            }

            let body = {
                chave: this.chaveNotaReferencia,
                codigoBarras: this.produtoCodigoBarrasReferencia,
                lote: lote,
                validade: validade,
                novoLote: novoLote,
                novaValidade: this.dateValueModalQuebrar,
                quantidade: quantidade,
                idUsuario: getUserId()
            };

            try {
                let response = await api.post('/inbound/primeiraconferencia/lotevalidade/quebrar', body);

                $("#modalQuebrarLoteValidade").modal('hide');
                this.listarProdutos(response.data);
                this.produtoReferencia = response.data;
                this.loteReferencia = novoLote;
                this.validadeReferencia = this.dateValueModalQuebrar;
                this.idDocumentoProdutoReferencia = response.data.iddocumentos_has_produtos;

                this.focusProduto();
            } catch (error) {
                this.errorGeral = error.message;
                this.playSound();
            }
        },

        changeSemLoteQuebrarLoteValidade() {
            if (!document.getElementById("loteInterruptorQuebrarLoteValidade").checked) {
                $("#novoLoteModalInput").val("");
                $("#novoLoteModalInput").prop("disabled", true);
                $("#novaValidadeModalInput").prop("disabled", true);
                $("#quantidadeQuebrar").val("");
                $("#quantidadeQuebrar").prop("disabled", true);
                this.dateValueModal = '';
            } else {
                $("#novoLoteModalInput").prop("disabled", false);
                $("#novaValidadeModalInput").prop("disabled", false);
                $("#quantidadeQuebrar").prop("disabled", false);
            }
        },

        changeSemLoteAjustarLoteValidade() {
            if (!document.getElementById("loteInterruptorAjustarLoteValidade").checked) {
                $("#loteAjustarInput").val("");
                $("#loteAjustarInput").prop("disabled", true);
                $("#validadeAjustarInput").prop("disabled", true);
                this.dateValueModal = '';
            } else {
                $("#loteAjustarInput").prop("disabled", false);
                $("#validadeAjustarInput").prop("disabled", false);
            }
        },

        changeSemLoteInserirLoteValidade() {
            if (!document.getElementById("loteValidadeInserirInterruptor").checked) {
                $("#loteModal").val("");
                $("#loteModal").prop("disabled", true);
                $("#validadeModal").prop("disabled", true);
                $("#quantidadeModal").val("");
                $("#quantidadeModal").prop("disabled", true);
                this.dateValue = '';
            } else {
                $("#loteModal").prop("disabled", false);
                $("#validadeModal").prop("disabled", false);
                $("#quantidadeModal").prop("disabled", false);
            }
        },

        showModalZerarConferencia() {
            $("#modalAcoes").modal("hide");
            $("#modalZerarConferencia").modal("show");
        },

        async zerarConferencia() {
            try {
                let body = {
                    chave: this.chaveNotaReferencia,
                    idDocumentoHasProduto: this.produtoReferencia.iddocumentos_has_produtos
                };

                let response = await api.post("/inbound/primeiraconferencia/zerarconferencia", body);

                this.listarProdutos(response.data);
                this.produtoReferencia = response.data;

                this.closeModal("modalZerarConferencia");
                this.primeiroBip = true;
                this.loteReferencia = null;
                this.validadeReferencia = null;
                this.idDocumentoProdutoReferencia = null;
                this.mostrarBotoesAcao = false;
                this.ultrapassaPrimeiraConferencia = false;
            } catch (e) {
                this.closeModal("modalZerarConferencia");
                this.errorGeral = e.message;
                this.playSound();
            }
        }
    },
}
</script>
  
<style scoped lang="scss">    
  
    .home-view {
      height: 100%;
    }
  
    .input-container input {
        width: 80%;
    }

    .icon-input-textarea {
        position: absolute;
        top: 5px;
        right: 5px;
        font-size: 18px;
    }

    input[type=checkbox] {
        accent-color: #6C757D;
        position: relative;
        top: 3px
    }

    .codigo-text {
        min-width: 60px;
    }

    /* Estilo opcional: Ajuste a cor do ícone */
    .icon {
        position: absolute;
        top: 5px;
        right: 46%;
        font-size: 18px;
        color: #df3333;  /* Ajuste a cor conforme necessário */
    }

</style>
  